import * as React from 'react';
import Footer from '../App/components/Layout/Footer/Footer';
import Header from '../App/components/Layout/Header/Header';
import MainNavigation from '../App/components/Layout/MainNavigation/MainNavigation';
import AccountChangeContainer from '../App/modules/Account/containers/AccountChange/AccountChangeContainer';
import withRouteMetadata from '../App/hocs/withRouteMetadata';
import { IRouteMetadataType } from '../App/modules/Base/types/IRouteMetadataType';
import { withRouter } from 'react-router';
import BaseRoute from './_BaseRoute';

class AccountChangeEmailRoute extends BaseRoute {
	public render () {

		return (
			<div>
				<Header />
				<MainNavigation />

				<AccountChangeContainer
					type="email"
				/>

				<Footer fluid={true} />
			</div>
		);
	}
}

export default withRouter(
	withRouteMetadata(
		AccountChangeEmailRoute,
		`accountChangeEmail`,
		{
			metaTitle: `Meine E-Mail Adresse ändern | Aktionsfinder`,
		} as IRouteMetadataSetterType
	)
);